module.exports = __webpack_public_path__ + "img/icon_arrow_left.04e98965.svg";